var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningMsgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23.074,
    viewBox: "0 0 25 23.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-warning",
    "data-name": "Icon ionic-ios-warning",
    d: "M14.245,5.455,3.6,24.876a1.826,1.826,0,0,0,1.628,2.7h21.29a1.83,1.83,0,0,0,1.628-2.7L17.5,5.455A1.865,1.865,0,0,0,14.245,5.455Zm2.686,8.058-.216,7.331H15.032l-.216-7.331ZM15.874,24.834a1.106,1.106,0,1,1,1.148-1.106A1.116,1.116,0,0,1,15.874,24.834Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#d09931"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningMsgIcon);
export default __webpack_public_path__ + "static/media/warning_msg_icon.d00241c24f8f3f94c355a36339d8c834.svg";
export { ForwardRef as ReactComponent };